import * as actionTypes from './actionTypes'
import { pageContext } from '../../context/'
import { User, Section, Page } from 'schema'
import * as api from 'api'
import { initData } from 'utils'
import { getTemplate } from 'templates'
import {ObjectId} from 'bson'
import { 
    getAuth, 
    createUserWithEmailAndPassword, 
    signInWithEmailAndPassword, 
    signOut,
    GoogleAuthProvider,
    FacebookAuthProvider,
    signInWithPopup,
    sendPasswordResetEmail,
    setPersistence,
    browserSessionPersistence,
    verifyBeforeUpdateEmail,
    getAdditionalUserInfo
} from "@firebase/auth";
// test here here
let auth
try {
    auth = getAuth()
} catch (err) {

}

export const authReset = () => {
    return {
        type: actionTypes.AUTH_RESET
    }
}

export const signUpFailure = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
}

export const getUserCount = (userId) => {
    return dispatch => {
        return api.countUserItems({userId})
        .then(res => {
            // console.log(res.data)
            dispatch({ type: actionTypes.USER_COUNT, created: res.data['created'], completed: res.data['completed'], incomplete: res.data['incomplete'] })
        })
        .catch(err => {

        })
    } 
}

///////////////////////
// SIGN-IN HANDLERS //
//////////////////////
export const signOutApp = () => {
    // window.location = `${process.env.REACT_APP_BASE_URL}/login`
    signOut(auth)
    localStorage.clear();

    return dispatch => {
        dispatch({type: actionTypes.SIGN_OUT})
        dispatch({type: actionTypes.SET_TOASTS, toast_ids: []})
    }
}

export const signUpEmail = (email, password) => {
    console.log('[auth.js] signUpEmail', {email: email, password: password})

    return dispatch => {
        let error;
        let data
        let user
        let template
        createUserWithEmailAndPassword(auth,email,password)
        .then( (firebaseRes) => {
            console.log('[signUpEmail] Firebase registered', firebaseRes)
            const firebaseUser = auth.currentUser;
            if (firebaseUser !== null) {
                // Create user in MongoDB
                const inboxID = new ObjectId().toString()
                const details = new User({
                    uid: firebaseRes.user.uid,
                    first_name: firebaseRes.user.displayName,
                    last_name: null,
                    email: firebaseRes.user.email,
                    // provider: firebaseRes.additionalUserInfo.providerId,
                    picture: firebaseRes.user.photoURL,
                    created: new Date().toString().slice(0,24),
                    theme: 'Dark',
                    full_width: false,
                    item_divider: false,
                    show_completed: false,
                    show_archived: false,
                    setup_completed: false,
                    activePageID: inboxID,
                    activePageType: pageContext.TYPES.PAGES,
                    inboxID: inboxID,
                    activePages: [],
                })
                api.createUser(details)
                .then(userResponse => {
                    console.log('[signUpEmail] User created', userResponse.data)
                    user = userResponse.data['user']
                    data = initData(userResponse.data['data'])
                    localStorage.setItem('--atomicly-uid', user['uid'])
                    localStorage.setItem('--atomicly-token', userResponse.data['token'])

                    template = getTemplate('getting-started', {userID: user['uid']})
                    return api.createPageTemplate({
                        user: user,
                        page: template['page'],
                        template: {
                            items: template['items'],
                            sections: template['sections']
                        }
                    })
                })
                .then(pageRes => {
                    console.log('[Page created]', pageRes)
                    user = new User(pageRes.data['user'])

                    // Update data with template data
                    const page = pageRes.data['page']
                    data['pages'][page['_id']] = new Page({...page, pageID: page._id})
                    template['items'].map(item => {
                        data['items'][item['itemID']] = item
                    })
                    template['sections'].map(section => {
                        data['sections'][section['sectionID']] = section
                    })

                    dispatch(signInThirdPartyHandler(user, error));
                    dispatch({ type:actionTypes.GET_DATA, data: data})
                })
                .catch(err => {
                    console.log('User not created', err)
                })           
            }                
        })
        .catch(function(err) {
            console.log('Firebase error', err)
            switch (err.code) {
                case 'auth/email-already-in-use': 
                    error = "Email already in use"
                    break
                case 'auth/invalid-email': 
                    error = "Invalid email"
                    break
                case 'auth/weak-password':
                    error = "Weak password"
                    break
                default:
                    error = "Something went wrong"
            }
            dispatch(signUpFailure(error));
        })
    }
}

// Sign in
export const signInExistingHandler = (user, error) => {
    console.log('[auth.js signInExisting]', {user: user, error: error})
    return ({
        type: actionTypes.SIGN_IN_EXISTING,
        user: user,
        error: error,
        isAuthenticated: user && !error
    })
}

export const signInExisting = (credential, page, callback) => {
    const debug = true
    const start_time = performance.now()
    let user;
    let data;
    let error;
    return dispatch => {
        api.loadUser()
        .then(response => {
            // User
            debug && console.log(`[signInExisting] Load data ${((performance.now() - start_time)/1000).toFixed(2)}s`)
            user = new User(response.data['user'])
            user['credential'] = credential
            localStorage.setItem('userid', user['uid'])

            // Data
            data = initData(response.data['data'])
            dispatch({
                type:actionTypes.GET_DATA,
                data: data,
                loadedPages: response.data['loadedPages'],
                loadedDates: response.data['loadedDates'],
                deferred: response.data['deferred']
            })

            // Redirect to page based on link
            if(page && page['id']){
                user['activePageID'] = page['id']
                user['activePageType'] = page['type']
            }

            dispatch({
                type: actionTypes.SIGN_IN_EXISTING,
                user: user,
                error: error,
                isAuthenticated: user && !error
            })
            dispatch({
                type: actionTypes.USER_COUNT,
                created: response.data.count['created'],
                completed: response.data.count['completed'],
                incomplete: response.data.count['incomplete']
            })
            dispatch({
                type: actionTypes.UPDATE_CLIENTS,
                clients: data['clients']
            })
            dispatch({
                type: actionTypes.UPDATE_WORKFLOWS,
                workflows: data['workflows']
            })
            // const sectionIds = Object.values(data.items).map(item => item['sectionID'])
            // console.log('[sections]',[...new Set(sectionIds)])
            debug && console.log(`[signInExisting] Completed ${((performance.now() - start_time)/1000).toFixed(2)}s with ${Object.keys(data.items).length} items and ${Object.keys(data.alerts).length} alerts`, { data, user })
            callback && callback()
        })
        .catch(err => {
            console.log('[auth.js signInExisting Error]', err)
            error = 'Something went wrong'
            dispatch({type: actionTypes.AUTH_FAIL, error: 'Your account and/or password is incorrect, please try again'})
        })
    }
}

export const signInEmailHandler = (user, error) => {
    console.log({user: user, error: error, isAuthenticated: user & !error})
    return {
        type: actionTypes.SIGN_IN,
        user: user,
        error: error,
        isAuthenticated: user && !error
    }
} 

export const signInEmail = (email, password) => {
    // Signing user in
    return dispatch => {
        let user;
        let data;
        let error;
        setPersistence(auth, browserSessionPersistence)
        .then(() => {
            signInWithEmailAndPassword(auth, email, password)
                .then( firebaseRes => {
                    // Call mongoDB to get user details
                    api.loadUser(firebaseRes.user.uid, firebaseRes._tokenResponse['idToken'])
                    .then(mongoRes => {
                        console.log(mongoRes)
                        // Data
                        data = initData(mongoRes.data['data'])
                        
                        // User
                        user = new User(mongoRes.data['user'])
                        user['credential'] = firebaseRes.credential;
                        user['pages'] = {
                            active: mongoRes.data['user']['activePages'], 
                            archive: mongoRes.data['user']['archivePages'], 
                            shared: mongoRes.data['user']['sharedPages']
                        }
                        // localStorage.setItem('userid', user['uid'])
                        localStorage.setItem('--atomicly-uid', user['uid'])
                        localStorage.setItem('--atomicly-token', mongoRes.data['token'])

                        dispatch({ 
                            type:actionTypes.GET_DATA, 
                            data: data, 
                            loadedPages: mongoRes.data['loadedPages'], 
                            loadedDates: mongoRes.data['loadedDates'],
                            deferred: mongoRes.data['deferred']
                        })
                        dispatch({ type: actionTypes.UPDATE_CLIENTS, clients: data['clients']})
                        
                        // Update email if need
                        if(user['email'] !== firebaseRes.user['email']){
                            api.updateUser(user.uid, {updates: {email: firebaseRes.user['email']}})
                            .then(updateRes => {
                                console.log('User updated')
                                user['email'] = firebaseRes.user['email']
                                dispatch(signInEmailHandler(user, error))
                            })
                            .catch(err => {
                                console.log('User email not updated', err)
                            })
                        } else {
                            dispatch(signInEmailHandler(user, error))
                        }
                    })
                    .catch(mongoErr => {
                        console.log('[signInEmail] Error', mongoErr)
                        error = 'Something went wrong'
                        dispatch(signInEmailHandler(user, error))
                    }) 
                })
                .catch( err => {
                    console.log('Firebase error', err)
                    switch (err.code) {
                        case 'auth/invalid-email': 
                            error = 'Invalid email'
                            break
                        case 'auth/user-disabled': 
                            error = 'User disabled'
                            break
                        case 'auth/user-not-found': 
                            error = 'Your account and/or password is incorrect, please try again'
                            break
                        case 'auth/wrong-password': 
                            error = 'Your account and/or password is incorrect, please try again'
                            break
                        default:
                            error = 'Something went wrong'
                    }
                    dispatch({type: actionTypes.AUTH_FAIL, error: error})
                })
        })
    }
}

export const signInThirdPartyHandler = (user, error) => {
    return {
        type: actionTypes.SIGN_IN_THIRD_PARTY,
        user: user,
        error: error,
        isAuthenticated: user & !error
    }
}

export const signInThirdParty = (type) => {
    const debug = true
    let error;
    let provider = type === 'GOOGLE' ? new GoogleAuthProvider()
                : type === 'FACEBOOK' ? new FacebookAuthProvider()
                : null;
    provider.setCustomParameters({
        prompt: "select_account"
    });
    debug && console.log('[signInThirdParty]', {type})

    return dispatch => {
        let user;
        let data;
        let template;
        signInWithPopup(auth, provider)
        .then(firebaseRes => {
            const ext = getAdditionalUserInfo(firebaseRes)
            console.log('[signInThirdParty] Sign in', {ext, firebaseRes})
            const isNew = ext['isNewUser']
            const uid = firebaseRes.user.uid
            // const isNew = true;

            // Create OR Get user in MongoDB
            if(isNew){
                const inboxID = new ObjectId().toString()
                let details = new User({
                    uid: firebaseRes.user.uid,
                    first_name: firebaseRes.user.displayName,
                    last_name: null,
                    email: firebaseRes.user.email,
                    provider: ext.providerId,
                    picture: firebaseRes.user.photoURL,
                    created: new Date().toString().slice(0,24),
                    theme: 'Dark',
                    full_width: false,
                    item_divider: false,
                    show_completed: false,
                    show_archived: false,
                    setup_completed: false,
                    activePageID: inboxID,
                    activePageType: pageContext.TYPES.PAGES,
                    inboxID: inboxID,
                    activePages: []
                })
                
                api.createUser(details)
                .then(userResponse => {
                    console.log('User created',firebaseRes.user.uid, userResponse.data['data'])
                    user = new User(userResponse.data['user'])
                    data = initData(userResponse.data['data'])
                    localStorage.setItem('--atomicly-uid', user['uid'])
                    localStorage.setItem('--atomicly-token', userResponse.data['token'])

                    template = getTemplate('getting-started', {userID: user['uid']})
                    return api.createPageTemplate({
                        user: user,
                        page: template['page'],
                        template: {
                            items: template['items'],
                            sections: template['sections']
                        }
                    })
                })
                .then(pageRes => {
                    console.log('[Page created]', pageRes)
                    user = new User(pageRes.data['user'])

                    // Update data with template data
                    const page = pageRes.data['page']
                    data['pages'][page['_id']] = new Page({...page, pageID: page._id})
                    template['items'].map(item => {
                        data['items'][item['itemID']] = item
                    })
                    template['sections'].map(section => {
                        data['sections'][section['sectionID']] = section
                    })

                    dispatch(signInThirdPartyHandler(user, error));
                    dispatch({ type:actionTypes.GET_DATA, data: data})
                })
            } else {
                // Call mongoDB to get user details
                // console.log({uid, token: firebaseRes._tokenResponse['idToken']})
                console.log(firebaseRes)
                api.loadUser(uid, firebaseRes._tokenResponse['idToken'])
                .then(mongoRes => {
                // api.getUserData(firebaseRes.user.uid).then(mongoRes => {
                    console.log('User retrieved',mongoRes)
                    data = initData(mongoRes.data['data'])
                    user = new User(mongoRes.data['user'])
                    user['credential'] = firebaseRes.credential;

                    localStorage.setItem('--atomicly-uid', uid)
                    localStorage.setItem('--atomicly-token', mongoRes.data['token'])
                    // setCookie('--atomicly-uid', firebaseRes.user.uid, 30)
                    // setCookie('--atomicly-token', mongoRes.data['token'], 30)

                    dispatch({ 
                        type:actionTypes.GET_DATA, 
                        data: data, 
                        loadedPages: mongoRes.data['loadedPages'], 
                        loadedDates: mongoRes.data['loadedDates'],
                        deferred: mongoRes.data['deferred']
                    })
                    dispatch(signInThirdPartyHandler(user, error));
                    dispatch({
                        type: actionTypes.UPDATE_CLIENTS,
                        clients: data['clients']
                    })
                }) 
                .catch(err => { console.log(err)})
            }
        })
        .catch(err => {
            debug && console.log('[signInThirdParty] Failed popup', err)
            if(err.code === 'auth/account-exists-with-different-credential'){
                error = "Account exists with different credentials"
            } else {
                error = "Something went wrong"
            }
            dispatch(signInThirdPartyHandler(null, error));
        })
    }
}

//////////////////
// EDIT ACCOUNT //
/////////////////
export const updateUser = (user, oldUser) => {
    console.log('[auth.js] updateUser', {new: user, old: oldUser})
    let error;
    let updatedUser = (({ credential, ...o }) => o)(user)
    return dispatch => {
        dispatch({
            type: actionTypes.UPDATE_USER,
            user: updatedUser,
            error: error
        })  

        api.updateUser(user.uid, {updates: updatedUser})
        .then(response => {
            
        })
        .catch(error => {
            console.log(error, oldUser)
            oldUser && dispatch({
                type: actionTypes.UPDATE_USER,
                user: oldUser,
                error: error
            })
            dispatch({type: actionTypes.ERROR, error: 'Something went wrong'})
        })
    }
}

export const updateEmail = (user, email) => {
    console.log('Update email', {user: user, email: email})
    // [TODO] Reauthenticate user
    return dispatch => {
        verifyBeforeUpdateEmail(auth.currentUser, email)
        .then(res => {
            console.log('Email sent')
            dispatch({type:actionTypes.AUTH_SUCCESS, success: {email: '*Please click on the link sent to your new email to verify'}})
        })
        .catch(err => {
            console.log('Email not sent', err)
            dispatch({type: actionTypes.AUTH_FAIL, error: {email: '*Something went wrong'}})
        })
    }
}

///////////////////////
// PASSWORD HANDLERS //
///////////////////////
export const resetPassword = (email) => {
    console.log('Reset password', email)
    return dispatch => {
        api.resetPassword({email})
        .then(res => {
            dispatch({type:actionTypes.AUTH_SUCCESS, success: {password: 'Please click on the link sent to your email to update your password'}})
        })
        .catch(err => {
            if(err.data['code'] === 'auth/user-not-found'){
                dispatch({type:actionTypes.AUTH_SUCCESS, success: {password: 'Please click on the link sent to your email to update your password'}})
            } else {
                const errorMessage = err.code === 'auth/too-many-requests' ? 'Please try again later'
                                    : 'Something went wrong'
                dispatch({type: actionTypes.AUTH_FAIL, error: {password: errorMessage}})
            }
        })
        // sendPasswordResetEmail(auth, email)
        // .then(res => {
        //     console.log('Reset password email sent')
        //     dispatch({type:actionTypes.AUTH_SUCCESS, success: {password: '*Please click on the link sent to your email to reset your password'}})
        // })
        // .catch(err => {
        //     console.log('Reset password email not sent', err)
        //     if(err.code === 'auth/user-not-found'){
        //         dispatch({type:actionTypes.AUTH_SUCCESS, success: {password: '*Please click on the link sent to your email to reset your password'}})
        //     } else {
        //         const errorMessage = err.code === 'auth/too-many-requests' ? '*Please try again later'
        //                             : '*Something went wrong'
        //         dispatch({type: actionTypes.AUTH_FAIL, error: {password: errorMessage}})
        //     }
        // })
    }
}

export const updatePassword = (oldPassword, newPassword, email) => {
    return dispatch => {
        // Reauthenticate
        setPersistence(auth, browserSessionPersistence)
        .then(res1 => {
            return signInWithEmailAndPassword(auth, email, oldPassword)
        })
        .then(res2 => {
            return auth.currentUser.updatePassword(newPassword)
        })
        .then(res => {
            console.log('Password updated', res)
            dispatch({type:actionTypes.AUTH_SUCCESS, success: {password: '*Password has been updated'}})
        })
        .catch(err => {
            console.log('Password not updated', err)
            dispatch({type: actionTypes.AUTH_FAIL, error: {password: '*Password is invalid'}})
        })
    }
}

export const changePasswordHandler = (error) => {
    return {
        type: actionTypes.CHANGE_PASSWORD,
        error: error
    }
}

export const changePassword = (newPassword, email, oldpassword, oldProfile) => {
    reauthenticate('password', email, oldpassword, oldProfile)
    return dispatch => {
        updatePassword(auth.currentUser, newPassword)
        .then(response => {
            dispatch({ type: actionTypes.CHANGE_PASSWORD, error: null });
        })
        .catch(function(error){
            dispatch({ type: actionTypes.CHANGE_PASSWORD, error: error.code === 'auth/requires-recent-login' ? 'Incorrect password' : error.message });
        })
        
    }
}

export const forgotPasswordHandler = (error) => {
    return {
        type: actionTypes.FORGOT_PASSWORD,
        errorMessages: error,
        resetPasswordEmailSent: error['email'].length === 0 ? true : false
    }
}

export const forgotPassword = (email) => {
    let errors = {email:[]};

    var actionCodeSettings = {
        url: 'https://localhost:3000/auth',
    };
    return dispatch => {
        // dispatch(authStart());
        sendPasswordResetEmail(auth, email, actionCodeSettings)
            .catch( (error) => {
                switch (error.code) {
                    case 'auth/invalid-email': 
                        errors['email'].push("Invalid email")
                    case 'auth/user-not-found': 
                        errors['email'].push("User not found")
                    default:
                        errors['email'].push("Something went wrong")
                }
            })
            .then( () => {
                dispatch(forgotPasswordHandler(errors));
            })
    }

}

///////////////////////
// REAUTHENTICATION //
//////////////////////
export const reauthenticationHandler = (profile, error) => {
    return {
        type: actionTypes.REAUTHENTICATE,
        profile: profile,
        error: error
    }
}

export const reauthenticate = (method, email, password, oldProfile) => {
    return dispatch => {
        if(method === 'password'){
            setPersistence(browserSessionPersistence)
                .then(() => {
                    signInWithEmailAndPassword(auth, email, password)
                        .then((response) => {
                            dispatch(reauthenticationHandler(response.user, null));
                        })
                        .catch((error) => {
                            dispatch(reauthenticationHandler(oldProfile, error.message))
                        })
                })
        } else if (method === 'google.com'){

        } else if (method === 'facebook.com'){

        }
    }
}